// extracted by mini-css-extract-plugin
export default {"quoteRightSidebar":"styles_quoteRightSidebar__WIZv+","noQuestionSelected":"styles_noQuestionSelected__zr6Ug","sidebarContainer":"styles_sidebarContainer__eXnO1"};